import { Navigate, Route } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";

import { Collection } from "./Collection";
import { CollectionAudit } from "./Collection/CollectionAudit";
import { CollectionDetailsTab } from "./Collection/CollectionDetailsTab";
import { CollectionItemsTab } from "./Collection/CollectionItemsTab";
import { CollectionPermissionDetails } from "./Collection/CollectionPermissionDetails";
import { CollectionTab } from "./Collection/useActiveCollectionTabFromUrl";
import { loadCollectionRecord } from "./loaders";
import { Collections } from "./ViewCollections";

export const CollectionsRoutes = () => [
  <Route
    key="/"
    index
    loader={loadSearchTablePreferences(
      queryClient,
      "collection_search_table_preferences",
    )}
    element={<Collections />}
  />,
  <Route
    key=":collectionId"
    path=":collectionId"
    loader={loadCollectionRecord(queryClient)}
    shouldRevalidate={({ currentParams, nextParams }) =>
      currentParams.collectionId !== nextParams.collectionId
    }
    element={<Collection />}
  >
    <Route index element={<Navigate to={CollectionTab.Items} replace />} />
    <Route path={CollectionTab.Items} element={<CollectionItemsTab />} />
    <Route path={CollectionTab.Details} element={<CollectionDetailsTab />} />
    <Route path={CollectionTab.Activity} element={<CollectionAudit />} />
    <Route
      path={CollectionTab.Permissions}
      element={<CollectionPermissionDetails />}
    />
    <Route path="*" element={<Navigate to={CollectionTab.Items} replace />} />
  </Route>,
];
